import { render, staticRenderFns } from "./age.vue?vue&type=template&id=0ec11f13&scoped=true&"
import script from "./age.vue?vue&type=script&lang=ts&"
export * from "./age.vue?vue&type=script&lang=ts&"
import style0 from "./age.vue?vue&type=style&index=0&id=0ec11f13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec11f13",
  null
  
)

export default component.exports